import React from 'react'
import { useNavigate } from 'react-router-dom'
import GlassPanel from '../components/UI/GlassPanel'
import EventDiscoveryWidget from '../components/EventDiscoveryWidget'

/**
 * Ticketmaster event discovery, on its own route.
 *
 * This widget fires a Ticketmaster search on mount. While it lived on the home
 * page that meant a third-party API call every single time anyone opened the
 * app — against a rate-limited developer key with a daily cap, spent mostly on
 * people who were not looking for new events. Behind its own route it costs a
 * call only when someone actually comes here.
 */
const Discover = () => {
  const navigate = useNavigate()

  return (
    <div className="p-4 sm:p-8">
      <div className="max-w-6xl mx-auto space-y-6">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div>
            <h1 className="text-3xl font-bold text-white">🎫 Discover Events</h1>
            <p className="text-gray-300 mt-1">
              Find upcoming shows near you and add them to your passport
            </p>
          </div>

          <button
            onClick={() => navigate('/newEvent')}
            className="bg-purple-600 hover:bg-purple-700 text-white font-medium py-2 px-4 rounded-lg transition-all duration-300"
          >
            + Add manually
          </button>
        </div>

        <GlassPanel>
          <EventDiscoveryWidget />
        </GlassPanel>
      </div>
    </div>
  )
}

export default Discover
